export default __webpack_public_path__ + "static/media/strong 4 core.00735108.png";